import { TranslateService } from '@ngx-translate/core';
import { PeriodoFiltro, TipoPeriodo } from '../../models/dashboard/periodo-filtro.model';
import { calcularPeriodoPredefinido, fmtDateTime } from './periodo.utils';

/**
 * Calcula o periodo padrao inicial para os relatorios que usam o
 * `app-periodo-filtro` (modo avancado).
 *
 * O `PeriodoFiltroComponent` NAO emite `periodoChanged` no `ngOnInit` — ele so
 * emite quando o usuario aplica um filtro no dialog. Por isso cada relatorio
 * precisa inicializar seus `params` (dataHoraInicial/dataHoraFinal) e o texto
 * do botao com este preset, replicando o que o dashboard faz em
 * `initPeriodoPadrao()`.
 *
 * As datas saem no formato `DD/MM/AAAATHH:MM` (via `fmtDateTime`), o mesmo que
 * os endpoints dos relatorios ja consomem.
 */
export function calcularPeriodoPadraoRelatorio(
  translate: TranslateService,
  tipo: TipoPeriodo = 'showAll',
): PeriodoFiltro {
  // Labels traduzidos esperados por `calcularPeriodoPredefinido` (mesmas chaves
  // usadas pelo PeriodoFiltroComponent).
  const labels: Record<TipoPeriodo, string> = {
    untilToday: translate.instant('dashboard.filtros.ate_hoje'),
    yesterdayAndToday: translate.instant('dashboard.filtros.ontem_e_hoje'),
    thisWeek: translate.instant('dashboard.filtros.esta_semana'),
    thisMonth: translate.instant('dashboard.filtros.este_mes'),
    untilMonthEnd: translate.instant('dashboard.filtros.ate_fim_do_mes'),
    prevMonth: translate.instant('dashboard.filtros.mes_anterior'),
    nextMonth: translate.instant('dashboard.filtros.proximo_mes'),
    last30: translate.instant('dashboard.filtros.ultimos_30_dias'),
    today: translate.instant('dashboard.filtros.hoje'),
    yesterday: translate.instant('dashboard.filtros.ontem'),
    showAll: translate.instant('dashboard.filtros.mostrar_todos'),
    custom: '',
  };

  const tipoStr = typeof tipo === 'number' ? 'thisMonth' : tipo;
  const result = calcularPeriodoPredefinido(tipoStr as TipoPeriodo, new Date(), labels, 0, 0, 23, 59);

  return {
    tipo: tipoStr,
    dataInicio: fmtDateTime(result.start),
    dataFim: fmtDateTime(result.end),
    texto: result.texto,
  };
}
